<template>
  <div class="flex-column align-center dialog-content singular">
    <div class="flex justify-space-around tab-wrapper">
      <button @click="changeTab(1)" class="text-left tab--btn pointer" :class="{active:currentTab === 1}">機械刻印（無料）</button>
      <button @click="changeTab(2)" class="text-left tab--btn pointer" :class="{active:currentTab === 2}">レーザー刻印（有料）</button>
    </div>

    <div class="flex contents-wrapper overflow-y">

      <div class="left-content content2 overflow-y no--sb" >
        <h4 class="title text-center">刻印の文字内容を入力</h4>
        <input type="text" v-model="option" class="oval" :disabled="!selectedItem" placeholder="20文字以内でご記入ください" maxlength="22">
        <span v-if="warningSelect" class="warning warningSelect">フォントを選択してください</span>
        <span v-if="warning && currentTab===1" class="warning">選択されたフォントは日本語をサポートできません</span>

        <!-- tab2 -->
        <p v-if="currentTab===2"
            class="flex align-center oval text-simulator"
           :class="{softColor:!option, Signerica_Medium: selectedItem && arrangeSelectedItem(selectedItem.val) ==='sign',
                    YuGothic: selectedItem && arrangeSelectedItem(selectedItem.val) === 'gothic',
                    Braisetto: selectedItem && arrangeSelectedItem(selectedItem.val) === 'tamari',
                    caflisch: selectedItem && arrangeSelectedItem(selectedItem.val) === 'handwritten',
                    YuMincho: selectedItem && arrangeSelectedItem(selectedItem.val) === 'mincho',
                    }">
          {{option ? option : "選んだ書体でメッセージが表示されます。"}}
        </p>
        <span v-if="warning && currentTab===2" class="warning">選択されたフォントは日本語をサポートできません</span>
        <span v-if="currentTab===2" class="counter">{{option ? option.replace(/\s+/g, "").length +" 文字" : ""}}</span>

        <div v-if="currentTab===2" class="oval flex caution-container">
          <i class="fas fa-info-circle"></i>
          <p>・20文字以内でご記入ください。<br>
            ・20文字以内は一律9,000円、それ以上は1文字300円となります。</p>
        </div>
        <!-- tab2 end -->
      </div>

      <div class="left-content content1 overflow-y no--sb">
        <div class="button-container" v-for="(data, idx) in tabData" :key="idx">
          <button class="flex align-center rounded pointer"
                  :class="{active: selectedItem && selectedItem.val === data.val}"
                  @click="storeItem2(data)">
            <span class="text">{{data.name}}</span>
            <span v-if="data.val !== 'undecided'" class="detail" @click="toggleSubDialog(data, true)">詳しく</span>
          </button>
        </div>
        <div class="button-container">
          <button 
            class="flex align-center rounded pointer"
            @click="arrangeNextTo()">
            <span class="text">刻印は不要</span>
          </button>
        </div>
        <div class="oval flex caution-container"  v-if="currentTab===1">
          <i class="fas fa-info-circle"></i>
          <p>
            ・お入れできる記号は、「&」「to」「-」「.」「/」「＋」「♡」<br>
            ・toなど記号、スペースは1文字となります。<br>
            ・ブロック体はアルファベット大文字、数字・記号が使えます。<br>
            ・筆記体はアルファベット大文字と小文字、数字、記号が使えます。<br>
            ・筆記体は2.4mm幅以上〜<br>
            ・刻印はシミュレーターには表示されません</p>
        </div>
        
        <!-- <div v-if="currentTab===2" class="teleported-content2 show">
          <h4 class="title text-center">刻印の文字内容を入力</h4>
          <input type="text" v-model="option" class="oval" :disabled="!selectedItem" placeholder="20文字以内でご記入ください" maxlength="22">
          <p class="flex align-center oval text-simulator"
             :class="{softColor:!option, Signerica_Medium: selectedItem && selectedItem.val ==='サイン',
                    YuGothic: selectedItem && selectedItem.val === 'gothic',
                    Braisetto: selectedItem && selectedItem.val === 'tamari風',
                    caflisch: selectedItem && selectedItem.val === '手書き風',
                    YuMincho: selectedItem && selectedItem.val === 'mincho',
                    }">
            {{option ? option : "選んだ書体でメッセージが表示されます。"}}
          </p>
          <span v-if="warning" class="warning">選択されたフォントは日本語をサポートできません</span>
          <span class="counter">{{option ? option.length +" 文字" : ""}}</span>

          <div class="oval flex caution-container">
            <i class="fas fa-info-circle"></i>
            <p>・20文字以内でご記入ください。<br>
              ・10文字以内は一律9,000円、それ以上は1文字300円となります。</p>
          </div>
        </div> -->
      </div>
      
    </div>

    <transition name="slideUp">
      <div class="flex align-center justify-center select-button" :class="{tab2:currentTab===2}" v-if="selectedItem">
        <button class="oval transition pointer" @click="removeItem(selectedItem)">選択解除</button>
        <button class="oval transition pointer choice" @click="selectItem()">選択</button>
      </div>
    </transition>
  </div>
</template>

<script>
import useDialogBuilder from "@/modules/moduleA/helpers/useDialogBuilder";
import {ref, watch} from "vue";
import useImageBuilder from "@/modules/moduleA/helpers/useImageBuilder";
import useRules from "@/modules/moduleA/helpers/useRules";
import useRoutePush from "@/modules/moduleA/helpers/useRoutePush";
import useToggleDialog from "@/modules/moduleA/helpers/useToggleDialog";

export default {
  name: "DiType6",
  props:{stepData:Array,},
  setup(props) {
    const {currentRoute, toggleSubDialog, storeItem, selectItem, removeItem, selectedItem} = useDialogBuilder()
    const {currentImage} = useImageBuilder(currentRoute.value)
    const {applyRule} = useRules(currentRoute.value)
    const {nextTo} = useRoutePush()
    const {toggleDialog} = useDialogBuilder();
    const currentTab = ref(1)
    const tabData = ref([])
    const option = ref(null)
    const warning = ref(false)
    const warningSelect = ref(true)
    option.value = selectedItem.value ? selectedItem.value.option : null

    if (selectedItem.value){
      currentTab.value = selectedItem.value.tab
      option.value = selectedItem.value.option
      warningSelect.value = false
    }

    tabData.value = props.stepData.filter(item => {
      return item.tab === currentTab.value
    })

    const changeTab = (tab) => {
      currentTab.value = tab
      tabData.value = props.stepData.filter(item => {
        return item.tab === tab
      })
    }

    const storeItem2 = (data) => {
      warningSelect.value = false
      storeItem(data)
    }

    const arrangeNextTo = () => {
      removeItem(selectedItem)
      toggleDialog(false)
      nextTo()
    }

    const arrangeSelectedItem = (val) => {
      if(val.includes("_")){
        return val.split("_")[0]
      }else{
        return val
      }
    }


    watch(() => currentTab.value, (to, from) => {
      removeItem()
      option.value = null
      warningSelect.value = true
      // if(selectedItem){
      //   warningSelect.value = false
      // }
    })

    watch(() => option.value, (val) => {
      if (selectedItem && val){
        if ((selectedItem.value.val !== "mincho" && selectedItem.value.val !== "gothic") &&
            val.match(/[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/)){
          warning.value = true
          option.value = null
        } else if(selectedItem) {
          if(selectedItem.value.val==='undecided'){
            option.value = null
            storeItem(selectedItem.value,null)
          } else {
            selectedItem.value.option = val
            storeItem(selectedItem.value,selectedItem.value.option)
            if (val.length){
              warning.value = false
            }
          }
        }
      }
    })

    watch(() => selectedItem.value, (val) => {
      if(option.value){
        val = option.value;
        if (selectedItem.value !==null && val){
          if ((selectedItem.value.val !== "mincho" && selectedItem.value.val !== "gothic") &&
              val.match(/[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/)){
            warning.value = true
            option.value = null
            
          } else if(selectedItem.value.val==='undecided'){
              console.log('else undec')
              option.value = null
              storeItem(selectedItem.value,null)
          } else {
            warning.value = false
            selectedItem.value.option = val
            storeItem(selectedItem.value,selectedItem.value.option)
            if (val.length){
              warning.value = false
            }
          }
        }
      }
    })

    return {
      currentRoute, toggleSubDialog, storeItem, selectItem, removeItem, selectedItem, currentImage, applyRule,
      currentTab, tabData, changeTab, option, warning, warningSelect, storeItem2, arrangeNextTo, arrangeSelectedItem,
    }

  }
}
</script>

<style scoped>
.dialog-content {
  height: calc(100% - 30px);
}
.dialog-content > .contents-wrapper {
  -webkit-box-direction:reverse;
  -moz-box-direction:reverse;
  -webkit-box-orient:horizontal;
  -moz-box-orient:horizontal;
  -webkit-flex-direction:row-reverse;
  -moz-flex-direction:row-reverse;
  flex-direction:row-reverse;
}
.dialog-content > .contents-wrapper > .content1 {
  width: 360px;
  height: auto;
  margin-top: 40px;
  padding-right: 20px;
}
.dialog-content > .contents-wrapper > .content2 {
  width: 360px;
  padding-left: 20px;
  height: auto;
  margin-top: 40px;
}
.dialog-content > .contents-wrapper > .left-content > h5.title {
  padding-left: 10px;
  font-size: 1rem;
  font-weight: 400;
  margin-bottom: 10px;
  margin-top: 30px;
}
.dialog-content > .contents-wrapper > .left-content > h5.title:first-child {
  margin-top: 0;
}
.dialog-content > .contents-wrapper > .left-content > div.button-container {
  height: 44px;
  width: 100%;
  margin-bottom: 10px;
}
.dialog-content > .contents-wrapper > .left-content > div.button-container:hover > button {
  border-color: #000;;
}
.dialog-content > .contents-wrapper > .left-content > div.button-container:last-child {
  margin-bottom: 0;
}
.dialog-content > .contents-wrapper > .left-content > div.button-container > button {
  width: 100%;
  border: 1px solid #d2dae2;
  height: 100%;
}
.dialog-content > .contents-wrapper > .left-content > div.button-container > button.active {
  border-color: #000;
  background-color: #f5f6fa;
  box-shadow: inset 0 0 0 0 transparent, 0 1px 8px 0 rgba(0, 0, 0, .1);
}
.dialog-content > .contents-wrapper > .left-content > div.button-container > button > .chip {
  display: block;
  width: 30px;
  height: 30px;
}
.dialog-content > .contents-wrapper > .left-content > div.button-container > button > .text {
  margin-left: 10px;
  font-size: .9rem;
}
.dialog-content > .contents-wrapper > .left-content > div.button-container > button.active > .chip {
  box-shadow: inset 0 0 0 0 transparent, 0 1px 8px 0 rgba(0, 0, 0, .1);
  border: 1px solid #dcdde1;
}
.dialog-content > .contents-wrapper > .left-content > div.button-container > button > .detail {
  margin-left: auto;
  margin-right: 10px;
  top: 1px;
  font-size: .8rem;
  color: gray;
  position: relative;
}
.dialog-content > .contents-wrapper > .left-content > div.button-container > button > .detail::after {
  position: absolute;
  content: "";
  bottom: -2px;
  left: 50%;
  transform: translateX(-50%);
  height: 1px;
  background-color: gray;
  width: 20px;
}

.dialog-content > .contents-wrapper > .content1 > .caution-container > .teleported-content2,
.dialog-content > .contents-wrapper > .content2 > .caution-container,
.dialog-content > .contents-wrapper > .content1 > .caution-container {
  margin-top: 20px;
  background-color: #f5f6fa;
  padding: 10px;
}
.dialog-content > .contents-wrapper > .content1 > .caution-container > .teleported-content2 > p,
.dialog-content > .contents-wrapper > .content2 > .caution-container > p,
.dialog-content > .contents-wrapper > .content1 > .caution-container > p {
  margin-left: 10px;
  font-size: .8rem;
}
.dialog-content > .contents-wrapper > .content1 > .teleported-content2 > .title,
.dialog-content > .contents-wrapper > .content2 > .title {
  margin-bottom: 20px;
  font-weight: 400;
}
.dialog-content > .contents-wrapper > .content1 > .teleported-content2 > input,
.dialog-content > .contents-wrapper > .content1 > .teleported-content2 > .text-simulator,
.dialog-content > .contents-wrapper > .content2 > input,
.dialog-content > .contents-wrapper > .content2 > .text-simulator {
  width: 100%;
  height: 50px;
  font-size: 1rem;
  padding-left: 10px;
  border: 1px solid #dcdde1;
}
.dialog-content > .contents-wrapper > .content1 > .teleported-content2 > span.counter,
.dialog-content > .contents-wrapper > .content2 > span.counter {
  display: block;
  height: 20px;
  width: 50px;
  margin-left: 10px;
  font-size: .8rem;
}
.dialog-content > .contents-wrapper > .content1 > .teleported-content2 > span.warning,
.dialog-content > .contents-wrapper > .content2 > span.warning {
  display: block;
  height: 20px;
  color: red;
  margin-left: 10px;
  font-size: .8rem;
}
.dialog-content > .contents-wrapper > .content2 > span.warningSelect {
  transition: .3s;
}
.dialog-content > .contents-wrapper > .content1 > .teleported-content2 > .text-simulator,
.dialog-content > .contents-wrapper > .content2 > .text-simulator {
  margin: 10px 0;
  border-style: dashed;
  background-color: #f5f6fa;
  font-size: 1.2rem;
}
.dialog-content > .contents-wrapper > .content1 > .teleported-content2 > .text-simulator.Signerica_Medium,
.dialog-content > .contents-wrapper > .content2 > .text-simulator.Signerica_Medium {
  font-family: Signerica_Medium, serif;
}
.dialog-content > .contents-wrapper > .content1 > .teleported-content2 > .text-simulator.YuMincho,
.dialog-content > .contents-wrapper > .content2 > .text-simulator.YuMincho {
  font-family: "YuMincho", serif
}
.dialog-content > .contents-wrapper > .content1 > .teleported-content2 > .text-simulator.Braisetto,
.dialog-content > .contents-wrapper > .content2 > .text-simulator.Braisetto {
  font-family: braisetto, script, serif;
  font-size: 2.0rem;
}
.dialog-content > .contents-wrapper > .content1 > .teleported-content2 > .text-simulator.caflisch,
.dialog-content > .contents-wrapper > .content2 > .text-simulator.caflisch {
  font-family: caflisch-script-pro, sans-serif;
}
.dialog-content > .contents-wrapper > .content1 > .teleported-content2 > .text-simulator.YuGothic,
.dialog-content > .contents-wrapper > .content2 > .text-simulator.YuGothic {
  font-family: "游ゴシック体", YuGothic, "游ゴシック Medium", "Yu Gothic Medium", "游ゴシック", "Yu Gothic", sans-serif;
}
.dialog-content > .contents-wrapper > .content1 > .teleported-content2 > .text-simulator.softColor,
.dialog-content > .contents-wrapper > .content2 > .text-simulator.softColor {
  margin: 10px 0;
  font-size: .7rem;
  color: #797979;
}

.dialog-content > .select-button {
  margin-top: 40px;
  border-bottom-right-radius: 14px;
  border-bottom-left-radius: 14px;
  height: 70px;
  width: 100%;
}
.dialog-content > .select-button > button {
  position: relative;
  z-index: 2;
  width: 100px;
  height: 40px;
  margin: 0 10px;
  padding-top: 2px;
  letter-spacing: 1.2px;
  background-color: rgba(245, 246, 250, .3);
  border: 2px solid rgba(220, 221, 225,1.0);
  color: #22252f;
}
.dialog-content > .select-button > button.choice {
  transform: translateY(-3px);
  background-color: #171717;
  border-color: white;
  color: white;
}
.dialog-content > .select-button > button:hover {
  transform: translateY(-3px);
  background-color: #171717;
  border-color: white;
  color: white;
}
.dialog-content > .tab-wrapper > button {
    font-size: 1.05em;
}

@media screen and (max-width: 724px){
  .overlay > .window > .content > .dialog-content > .contents-wrapper {
    overflow-y: scroll;
    display: block;
    padding-bottom: 60px;
  }
  .dialog-content > .select-button {
    background-color: white;
    position: absolute;
    bottom: 0;
  }
  .overlay > .window > .content > .dialog-content > .left-content.content2,
  .overlay > .window > .content > .dialog-content > .contents-wrapper > .left-content.content2 {
    display: block;
  }
  .dialog-content > .contents-wrapper > .content2 {
    width: auto;
    padding-left: 0px;
    height: auto;
    margin-top: 0px;
  }
  .overlay > .window > .content > .dialog-content > .contents-wrapper > .left-content.content2 > h4.title {
    margin-top: 20px;
    margin-bottom: 10px;
  }
  .overlay > .window > .content > .dialog-content > .contents-wrapper > .left-content.content2 > div.caution-container {
    font-size: .8rem;
    margin-top: 10px;
    background-color: #f5f6fa;
    padding: 10px;
  }
}
</style>
